import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class IncidentFormsService {

    constructor(
        private http: HttpClient
    ) { }

    getIncidentForms() {
        return this.http.get(environment.serverUrl + '/incidents/forms');
    }

}



// WEBPACK FOOTER //
// ./src/app/incident-forms/incident-forms.service.ts